var _rect, _ellipse, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationPanelLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.3256,
    y: 21.9047,
    width: 17.6744,
    height: 17.1429,
    rx: 2,
    fill: "#6B7280"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.76751,
    cy: 30.9523,
    rx: 8.83721,
    ry: 9.04762,
    fill: "#6B7280"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49169 3.07866C9.25738 1.72461 11.2079 1.72461 11.9735 3.07865L18.7775 15.1108C19.5314 16.444 18.5682 18.0952 17.0366 18.0952H3.42866C1.897 18.0952 0.933794 16.444 1.68773 15.1108L8.49169 3.07866Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5979 3.48911C37.6829 2.46738 36.4275 1.90466 35.0626 1.90466C34.0424 1.90466 33.108 2.23677 32.2855 2.89168C31.8704 3.22226 31.4944 3.6267 31.1628 4.09876C30.8313 3.62684 30.4551 3.22226 30.0399 2.89168C29.2175 2.23677 28.2832 1.90466 27.2629 1.90466C25.898 1.90466 24.6425 2.46738 23.7275 3.48911C22.8235 4.4989 22.3256 5.87842 22.3256 7.37373C22.3256 8.91278 22.8826 10.3216 24.0785 11.8075C25.1484 13.1366 26.686 14.4858 28.4667 16.0482C29.0747 16.5818 29.7639 17.1866 30.4795 17.8308C30.6686 18.0013 30.9111 18.0951 31.1628 18.0951C31.4143 18.0951 31.657 18.0013 31.8458 17.8311C32.5614 17.1867 33.251 16.5816 33.8593 16.0478C35.6396 14.4857 37.1773 13.1366 38.2471 11.8073C39.4431 10.3216 40 8.91278 40 7.37359C40 5.87842 39.502 4.4989 38.5979 3.48911Z",
    fill: "#6B7280"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationPanelLogo);
export default __webpack_public_path__ + "static/media/navigation-panel-logo.3d401bdc682cec0d2d771de0bf6d41f4.svg";
export { ForwardRef as ReactComponent };